import React, { Component, Fragment } from 'react';
import axios from 'axios';
import {
    Segment,
    Grid,
    Loader,
    Button,
    Header,
    Icon, Checkbox
} from 'semantic-ui-react';
import { toast, ToastContainer } from 'react-toastify';
import { FormattedMessage } from 'react-intl';
import ExternalStudentPersonalInformationForm
    from '../../ExternalStudents/ExternalStudentForms/ExternalStudentPersonalInformationForm';
import ExternalStudentSendingInstitutionForm
    from '../../ExternalStudents/ExternalStudentForms/ExternalStudentSendingInstitutionForm';
import ExternalStudentExchangeInformationForm
    from '../../ExternalStudents/ExternalStudentForms/ExternalStudentExchangeInformationForm';
import {
    externalStudentToBodyMapper,
    validateExternalStudent
} from '../../ExternalStudents/ExternalStudentForms/ExternalStudentInputForm';

class ExternalStudentInputForm extends Component {
    state = {
        student: null,
        errors: {},
        loading: true,
        creatingExternalStudent: false,
        errorMessage: null,
        successMessage: null,
        consentAccepted: false,
    };

    constructor() {
        super();

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    getDeepCopy = (obj) => {
        return JSON.parse(JSON.stringify(obj));
    };

    componentDidMount() {
        window.$locale = window.$locale || 'en';

        this.setState({
            student: {},
        });
        const code = this.props.match.params.code;
        axios.get(`/public/external-student/registration-link/${code}`)
            .then((res) => {
                const registrationLinkData = res.data;
                this.setState({
                    loading: false,
                    student: this.getDeepCopy(registrationLinkData),
                    registrationLinkData
                });
            })
            .catch(() => {
                this.setState({
                    loading: false,
                    errorMessage: true
                });
            });
    }

    handleSubmit = () => {
        const { student } = this.state;

        const body = externalStudentToBodyMapper(student);

        const errors = validateExternalStudent(student);
        this.setState({ errors });
        if (Object.values(errors)
            .some((err) => err)) {
            toast(<FormattedMessage id="externalStudent.toast.fillRequiredFields"/>);
            return;
        }

        if (student.mobilityType._key === 'non_cycle' && body.dateFrom && body.dateTo && new Date(body.dateFrom) >= new Date(body.dateTo)) {
            toast(<FormattedMessage id="externalStudent.toast.startDateBeforeEndDate"/>);
            return;
        }

        this.setState({ creatingExternalStudent: true }, () => {
            axios.post(`/public/external-student/${this.props.match.params.code}`, body)
                .then((res) => {
                    this.setState({
                        creatingExternalStudent: false,
                        successMessage: true,
                    });
                })
                .catch(() => {
                    this.setState({
                        creatingExternalStudent: false,
                    });
                    toast(<FormattedMessage id="externalStudent.toast.errorWhileSubmittingData"/>);
                });
        });
    };

    handleChange = (updatedFields) => {
        this.setState((prevState) => ({
            student: {
                ...prevState.student,
                ...updatedFields
            }
        }));
    };

    render() {
        const {
            student,
            errors,
            loading,
            creatingExternalStudent,
            consentAccepted
        } = this.state;

        const Centered = ({ children }) => (
            <Segment
                basic
                textAlign="center"
                vertical
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100vh',
                    width: '100vw',
                }}
            >
                {children}
            </Segment>
        );

        if (this.state.errorMessage) {
            return (
                <Centered>
                    <Icon name="times circle outline" size="huge" color="red"/>
                    <Header as="h2" color="red">
                        <FormattedMessage id="externalStudent.registrationLinkNotFoundOrExpired"/>
                    </Header>
                    <Header.Subheader>
                        <FormattedMessage id="externalStudent.registrationLinkExpiredExplanation"/>
                    </Header.Subheader>
                </Centered>
            );
        }

        if (this.state.successMessage) {
            return (
                <Centered>
                    <Icon name="check circle" size="huge" color="green"/>
                    <Header as="h2" color="green" textAlign="center">
                        <FormattedMessage id="externalStudent.successfullySubmittedData"/>
                    </Header>
                    <Header.Subheader>
                        <FormattedMessage id="externalStudent.closeThisPageSafely"/>
                    </Header.Subheader>
                </Centered>
            );
        }

        if (loading || student === null) {
            return (
                <Centered>
                    <div style={{
                        paddingTop: 100,
                        paddingBottom: 100
                    }}>
                        <Loader active inline="centered"/>
                    </div>
                </Centered>
            );
        }

        return (
            <Segment basic secondary>
                <div style={{
                    textAlign: 'center',
                    marginTop: '1em',
                    marginBottom: '1em'
                }}>
                    <img
                        src={'../../../img/unsa-logo.png'}
                        alt="Logo"
                        style={{
                            maxWidth: '180px',
                            height: 'auto'
                        }}
                    />
                </div>
                <Header as="h1" textAlign={'center'} style={{
                    marginBottom: '1em'
                }}>
                    <Header.Content>
                        {<FormattedMessage id="externalStudent.enterPersonalAndInstitutionDataPublic"/>}
                    </Header.Content>
                </Header>
                <Fragment>
                    <Grid stackable columns={2} centered style={{ marginBottom: '2em' }}>
                        <Grid.Column>
                            <p style={{
                                marginBottom: '4em',
                                textAlign: 'justify'
                            }}>
                                {
                                    'Please fill in the form below with accurate personal, institutional, and exchange-related information. ' +
                                    'The data you provide will be used exclusively for processing your mobility application at the University of Sarajevo. ' +
                                    'Make sure that all required fields are completed and that the information matches your official documents. ' +
                                    'If you need assistance or have questions regarding the form, please contact the International Relations Office of your home institution or the University of Sarajevo. ' +
                                    'After submitting the form, you will receive a confirmation message. You will not be able to make further changes, so please review your entries carefully before submitting. '
                                }
                            </p>
                            <Segment.Group raised>
                                <ExternalStudentPersonalInformationForm student={student} errors={errors} publicForm
                                                                        onChangeStudent={this.handleChange}/>
                            </Segment.Group>
                            <Segment.Group raised>
                                <ExternalStudentSendingInstitutionForm student={student} errors={errors} publicForm
                                                                       onChangeStudent={this.handleChange}/>
                            </Segment.Group>
                            <Segment.Group raised>
                                <ExternalStudentExchangeInformationForm student={student} errors={errors} publicForm
                                                                        onChangeStudent={this.handleChange}/>
                            </Segment.Group>
                            <Segment basic textAlign={'center'}>
                                <Checkbox
                                    checked={this.state.consentAccepted}
                                    onChange={(e, { checked }) =>
                                        this.setState({ consentAccepted: checked })
                                    }
                                    label={
                                        <label style={{ fontSize: '0.95em' }}>
                                            <FormattedMessage id="externalStudent.consentText"/>
                                        </label>
                                    }
                                />
                            </Segment>
                            <Segment
                                basic
                                style={{
                                    display: 'flex',
                                    flexDirection: window.innerWidth < 768 ? 'column' : 'row',
                                    justifyContent: 'flex-end',
                                    alignItems: 'flex-end',
                                    gap: window.innerWidth < 768 ? '0.5em' : '0.5em'
                                }}
                            >
                                <Button
                                    size={'large'}
                                    color="blue"
                                    onClick={this.handleSubmit}
                                    loading={creatingExternalStudent}
                                    disabled={!consentAccepted}
                                    fluid={window.innerWidth < 768}
                                    style={{
                                        width: window.innerWidth < 768 ? '100%' : 'auto'
                                    }}
                                >
                                    <FormattedMessage id="externalStudent.submit"/>
                                </Button>
                                <Button
                                    size={'large'}
                                    basic
                                    color="blue"
                                    disabled={creatingExternalStudent}
                                    onClick={() => this.setState({ student: this.getDeepCopy(this.state.registrationLinkData) })}
                                    fluid={window.innerWidth < 768}
                                    style={{
                                        width: window.innerWidth < 768 ? '100%' : 'auto'
                                    }}
                                >
                                    <FormattedMessage id="externalStudent.clear"/>
                                </Button>
                            </Segment>
                        </Grid.Column>
                    </Grid>
                </Fragment>
                <ToastContainer position="top-right" hideProgressBar={true}/>
            </Segment>
        );
    }
}

export default ExternalStudentInputForm;



// WEBPACK FOOTER //
// ./src/views/Public/ExternalStudentForms/ExternalStudentInputForm.js